import React from 'react';

import { Button, Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import ReactHookFormInputDatePicker from 'common/components/form/ReactHookFormInputDatePicker';

const DateFilterForm = ({ onSubmit }) => {
    const { t } = useTranslation();
    const { control, handleSubmit } = useForm({
        defaultValues: { date: null },
        mode: 'onChange',
    });

    return (
        <Grid component="form" onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={2}>
                <Grid size={{ xs: 'grow' }}>
                    <ReactHookFormInputDatePicker
                        control={control}
                        fullWidth
                        label={t('Date')}
                        format="MM/yyyy"
                        inputFormat="MM/yyyy"
                        maxDate={new Date()}
                        name="date"
                        views={['year', 'month']}
                    />
                </Grid>

                <Grid>
                    <Button type="submit">{t('Download')}</Button>
                </Grid>
            </Grid>
        </Grid>
    );
};

DateFilterForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
};

export default DateFilterForm;
